var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57983 14.5174C1.57983 11.3948 4.11186 8.86279 7.23449 8.86279C10.3571 8.86279 12.8892 11.3948 12.8892 14.5174M7.23449 1.32324C6.40132 1.32324 5.60227 1.65422 5.01313 2.24336C4.42399 2.8325 4.09302 3.63155 4.09302 4.46472C4.09302 5.29789 4.42399 6.09694 5.01313 6.68608C5.60227 7.27522 6.40132 7.6062 7.23449 7.6062C8.06766 7.6062 8.86671 7.27522 9.45585 6.68608C10.045 6.09694 10.376 5.29789 10.376 4.46472C10.376 3.63155 10.045 2.8325 9.45585 2.24336C8.86671 1.65422 8.06766 1.32324 7.23449 1.32324Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.a9891ffcae9922c34241e2caa1e2c5ca.svg";
export { ForwardRef as ReactComponent };